import HttpService from './HttpService';
const API_ENDPOINT = '/gender';

const GenderStatus = {
  async getGenders() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getGendersPaginated(pageConfig) {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async addGender(data) {
    try {
      console.log('api end',API_ENDPOINT)
       const response = await HttpService.post(API_ENDPOINT, data);
       return response.data;
    } catch (error) {
        console.error('Error adding gender:', error);
        throw error;
    }
},
async updateGender(genderId, data) {
 try {
     const response = await HttpService.put(`${API_ENDPOINT}/${genderId}`, data);
     return response.data;
 } catch (error) {
     console.error('Error updating gender:', error);
     throw error;
 }
},
async deleteGender(genderId) {
 try {
     const response = await HttpService.delete(`${API_ENDPOINT}/${genderId}`);
     return response.data;
 } catch (error) {
     console.error('Error deleting gender:', error);
     throw error;
 }
},
};

export default GenderStatus;